import validate from "/app/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@18.19.85_bufferutil@4.0.9_db0@0.3.1_eslin_90928d83ea08b43bfc813cc16d010b02/node_modules/nuxt/dist/pages/runtime/validate.js";
import maintenance_45global from "/app/apps/explorer/middleware/maintenance.global.ts";
import redirect_45first_45tab_45global from "/app/apps/explorer/middleware/redirect-first-tab.global.ts";
import redirect_45metamask_45urls_45global from "/app/apps/explorer/middleware/redirect-metamask-urls.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@18.19.85_bufferutil@4.0.9_db0@0.3.1_eslin_90928d83ea08b43bfc813cc16d010b02/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  maintenance_45global,
  redirect_45first_45tab_45global,
  redirect_45metamask_45urls_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}